import { apiInstance } from "../utils";

interface SaveEmailForNewsletterProps {
  email: string;
}

export const SaveEmailForNewsletter = async ({
  email,
}: SaveEmailForNewsletterProps) => {
  const response = await apiInstance.post("newslatter", { email });

  return response.data;
};
